import { render, staticRenderFns } from "./InstitutionalQnrView.vue?vue&type=template&id=d4b59d30&scoped=true&"
import script from "./InstitutionalQnrView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalQnrView.vue?vue&type=style&index=0&id=d4b59d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b59d30",
  null
  
)

export default component.exports